import React from 'react'

export default function LayoutsUpdateBrowser() {
  return (
    <section><a className="anchor" id="updatebrowser"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/updatebrowser.html"><img src="images/updatebrowser.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>Update Browser</h1>
            <p>Live examples of the update browser alert.</p>
            <p><a className="btn btn--large" href="samples/updatebrowser.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/updatebrowser.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsUpdateBrowser.js